export const MODEL_SOURCE = {
  title: 'Pulsar Financial',
  spreadsheetId: '1Q3ght7cZva6ZCA3fqyzyazBjMAkMouoaE1yOEHreQpE',
  tabs: ['Dashboard', 'Base Case', 'Revenue Engine'],
};

export const MODEL_MONTHS = [
  { month: 'M0', b2cArr: 0, b2bArr: 750000, cardholders: 0, totalArr: 750000 },
  { month: 'M1', b2cArr: 0, b2bArr: 812500, cardholders: 0, totalArr: 812500 },
  { month: 'M2', b2cArr: 259422, b2bArr: 875000, cardholders: 6000, totalArr: 1134422 },
  { month: 'M3', b2cArr: 522594, b2bArr: 937500, cardholders: 12000, totalArr: 1460094 },
  { month: 'M4', b2cArr: 789516, b2bArr: 1000000, cardholders: 18000, totalArr: 1789516 },
  { month: 'M5', b2cArr: 1088988, b2bArr: 1062500, cardholders: 24000, totalArr: 2151488 },
  { month: 'M6', b2cArr: 1370610, b2bArr: 1125000, cardholders: 30000, totalArr: 2495610 },
  { month: 'M7', b2cArr: 1916646, b2bArr: 1187500, cardholders: 41667, totalArr: 3104146 },
  { month: 'M8', b2cArr: 2469973, b2bArr: 1250000, cardholders: 53333, totalArr: 3719973 },
  { month: 'M9', b2cArr: 3030593, b2bArr: 1312500, cardholders: 65000, totalArr: 4343093 },
  { month: 'M10', b2cArr: 3598503, b2bArr: 1375000, cardholders: 76667, totalArr: 4973503 },
  { month: 'M11', b2cArr: 4173706, b2bArr: 1437500, cardholders: 88333, totalArr: 5611206 },
  { month: 'M12', b2cArr: 4756200, b2bArr: 1500000, cardholders: 100000, totalArr: 6256200 },
];

export const MODEL_CHECKPOINTS = {
  m0: MODEL_MONTHS[0],
  m6: MODEL_MONTHS[6],
  m12: MODEL_MONTHS[12],
};

export const REVENUE_LINES = [
  {
    label: 'Trading revenue',
    shortLabel: 'Trading',
    monthlyPerCardholder: 1.138,
    m12MonthlyRevenue: 113750,
    note: 'Spot/swaps at 0.75% and perps at 0.25%, blended into cardholder usage.',
  },
  {
    label: 'Subscription revenue',
    shortLabel: 'Subscriptions',
    monthlyPerCardholder: 0.875,
    m12MonthlyRevenue: 87500,
    note: 'Pro and Ultra conversion blended into monthly revenue per cardholder.',
  },
  {
    label: 'FX + remittance revenue',
    shortLabel: 'FX + remittance',
    monthlyPerCardholder: 1.188,
    m12MonthlyRevenue: 118750,
    note: 'FX, remittance, off-ramp, and token on-ramp fees.',
  },
  {
    label: 'Credit products revenue',
    shortLabel: 'Credit products',
    monthlyPerCardholder: 0.1,
    m12MonthlyRevenue: 10000,
    note: 'Borrowing, card credit, or lending-style balances after active borrower uptake.',
  },
  {
    label: 'Interchange revenue',
    shortLabel: 'Interchange',
    monthlyPerCardholder: 0.351,
    m12MonthlyRevenue: 35100,
    note: 'Card spend after card program, KYC, setup, and operating costs.',
  },
  {
    label: 'Yield product revenue',
    shortLabel: 'Yield product',
    monthlyPerCardholder: 0.313,
    m12MonthlyRevenue: 31250,
    note: 'Retained share of yield on a Month 12 deposit base of $75M.',
  },
];

export const MODEL_ASSUMPTIONS = {
  month12B2cMonthlyRevenue: 396350,
  month12RevenuePerCardholder: 3.96,
  month12KnownMonthlyCosts: 206413,
  month12YieldDeposits: 75000000,
  baseYieldApy: 0.045,
  pulsarRewardFee: 0.2,
  startingB2bArr: 750000,
  month12B2bArr: 1500000,
};

export function getModelMonth(month) {
  return MODEL_MONTHS.find((row) => row.month === month);
}
